import { Injectable } from '@angular/core';
import { AngularFirestore } from 'angularfire2/firestore';
import { first } from '../../../../node_modules/rxjs/operators';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TrackerService {

  constructor(private afs: AngularFirestore) { }

  getRoute(userId: string, date: string, startTime: string, endTime: string): Observable<any[]> {

    let start = new Date(date + ' ' + startTime);
    let end = new Date(date + ' ' + endTime);

    console.log(userId, date, startTime, endTime);

    return this.afs.collection('locations').doc(userId).collection(date, 
            ref => ref
                .where('time', '>', start)
                .where('time', '<', end)
                .orderBy('time', 'asc')).valueChanges();
    
  }
}
